import React from 'react';
import FeatureCard from './FeatureCard';
import { FiAward, FiClock, FiFileText, FiHeadphones, FiLayers, FiMessageSquare, FiShield, FiUsers } from 'react-icons/fi';

export default function Features() {
  const featureItems = [
    {
      title: 'Simplified management of your subscriptions',
      icon: <FiLayers />,
      eyebrow: 'Management',
      text: 'personalfinancecare.com offers you to easily manage different subscriptions. Fill in the e-mail address you used when you subscribed and reach your customer account in one click.',
    },
    {
      title: 'All the essential information',
      icon: <FiFileText />,
      eyebrow: 'Control',
      text: 'All the essential information is there to give you maximum control of your subscriptions. You can also contact the agents to ask for help, unsubscribe or make a complaint.',
    },
    {
      title: 'Agents at your service',
      icon: <FiHeadphones />,
      eyebrow: 'Support',
      text: 'Our agents are experts in after-sales services and have all the answers to your questions. We work 7 days per week, so you can contact the agents by live chat or by phone.',
    },
    {
      title: 'Recognized expertise',
      icon: <FiAward />,
      eyebrow: 'Expertise',
      text: 'We provide the after-sales service of several partner sites, which are all satisfied with our services. Our expertise provides the support for every single client.',
    },
  ];

  const trustItems = [
    {
      icon: <FiClock />,
      title: '24/7 availability',
      text: 'Request support any time through our service desk.',
    },
    {
      icon: <FiShield />,
      title: 'Secure handling',
      text: 'Your request details are processed through a protected flow.',
    },
    {
      icon: <FiUsers />,
      title: 'Partner-trained agents',
      text: 'Experienced teams handle subscription and billing questions.',
    },
    {
      icon: <FiMessageSquare />,
      title: 'Clear communication',
      text: 'Straightforward answers, quick follow-up, and guided next steps.',
    },
  ];

  return (
    <section className="bg-[#E9F6F0] px-4 py-20 text-[#17231F] sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="max-w-3xl">
          <p className="text-base font-bold uppercase tracking-[0.18em] text-[#0D6D65]">Why choose us</p>
          <h2 className="mt-4 text-3xl font-semibold leading-tight text-[#0B2F2A] sm:text-4xl">Everything you need to manage your subscription in one place.</h2>
          <p className="mt-5 max-w-2xl text-base leading-8 text-[#2D4A43]">
            personalfinancecare.com offers you a simple way to manage subscriptions, contact agents, and access support from partner-trained teams.
          </p>
        </div>

        <div className="mt-12 grid gap-8 lg:grid-cols-[0.38fr_0.62fr]">
          <div className="rounded-2xl bg-[#0B2F2A] p-8 text-white lg:order-2">
            <div className="border-l-4 border-[#FCD34D] pl-5">
              <p className="text-sm font-semibold text-white">Simplified management</p>
              <p className="mt-2 text-sm leading-6 text-emerald-100/90">Fill in the email address you used when you subscribed and reach your customer account in one click.</p>
            </div>
            <div className="mt-8 border-l-4 border-white/20 pl-5">
              <p className="text-sm font-semibold text-white">Expert agents</p>
              <p className="mt-2 text-sm leading-6 text-emerald-100/90">Contact the agents by live chat or by phone if you need help with your subscription or any other question.</p>
            </div>

            <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2">
              {trustItems.map(item => (
                <div key={item.title} className="rounded-xl border border-white/10 bg-white/10 p-4">
                  <div className="flex items-center gap-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#FCD34D] text-[#0B2F2A]">
                      {React.cloneElement(item.icon, { className: 'h-4 w-4' })}
                    </span>
                    <h3 className="text-sm font-semibold text-white">{item.title}</h3>
                  </div>
                  <p className="mt-3 text-sm leading-6 text-emerald-100/90">{item.text}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-4 lg:order-1">
            {featureItems.map((item, index) => (
              <FeatureCard
                key={item.title}
                title={item.title}
                icon={item.icon}
                eyebrow={`${String(index + 1).padStart(2, '0')} / ${item.eyebrow}`}
              >
                {item.text}
              </FeatureCard>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
